module.exports = __webpack_public_path__ + "img/t2_s.e8fb04bb.jpg";